interface INotificationState {
  count: number
}

export const NotificationInitialState: INotificationState = {
  count: 0,
}
